import { EVENTS, STORAGE_KEYS } from "const";
import AppBridgeHelper from "helpers/AppBridgeHelper";
import FirebaseService from "services/FirebaseService";
import TerminalService from "services/TerminalService";
import { eventsEmitter } from "./events";

function notificationTokenGenerated(notifiationToken: { type: string; token: string }) {
  console.log("Notification token generated:", notifiationToken);
  const tokenStr = `${notifiationToken.type}:${notifiationToken.token}`;
  updateNotificationTokenInServer(tokenStr);
}

function notificationReceived(payload: any) {
  console.log("Notification received:", payload);
  const data = JSON.parse(payload);
  eventsEmitter.emit(EVENTS.NEW_NOTIFICATION, { data });
}

async function reCreateAndStoreNotificationToken() {
  const notificationToken = await reCreateNotificationToken();
  if (!notificationToken) {
    return;
  }

  console.log("Generated notification token succesfully, ", notificationToken);
  await updateNotificationTokenInServer(notificationToken);
}

async function updateNotificationTokenInServer(notificationToken: string) {
  const currentToken = localStorage.getItem(STORAGE_KEYS.NOTIFICATION_TOKEN);
  if (currentToken === notificationToken) {
    return;
  }

  const terminalId = localStorage.getItem(STORAGE_KEYS.TERMINAL_ID);
  await TerminalService.updateTerminalNotificationToken(terminalId, notificationToken);
  localStorage.setItem(STORAGE_KEYS.NOTIFICATION_TOKEN, notificationToken);
  console.log("Stored notification token in server : ", notificationToken);
}

async function reCreateNotificationToken() {
  const bridge = AppBridgeHelper.getBridge();
  if (bridge) {
    const tokenJson = await bridge.generateNotificationToken();
    const token = JSON.parse(tokenJson);
    if (!token?.token) {
      return null;
    }
    return `${token?.type}:${token?.token}`;
  }

  return FirebaseService.reCreateFcmToken();
}

const NotificationHandler = {
  notificationTokenGenerated,
  notificationReceived,
  reCreateAndStoreNotificationToken,
};

export default NotificationHandler;
